import type { PromotionPreset } from "./types";

export const PRESET_STORAGE_KEY = "hawaii-dashboard-presets";
export const MAX_PRESETS = 20;

export function loadPresets(): PromotionPreset[] {
  try {
    const raw = localStorage.getItem(PRESET_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as PromotionPreset[]) : [];
  } catch {
    return [];
  }
}

export function persistPresets(presets: PromotionPreset[]): void {
  localStorage.setItem(PRESET_STORAGE_KEY, JSON.stringify(presets));
}

export function createPreset(name: string, mfes: string[]): PromotionPreset {
  return {
    id: crypto.randomUUID(),
    name,
    mfes: [...mfes].sort(),
    createdAt: new Date().toISOString(),
  };
}

export function deletePreset(presets: PromotionPreset[], id: string): PromotionPreset[] {
  return presets.filter((p) => p.id !== id);
}

export function renamePreset(presets: PromotionPreset[], id: string, name: string): PromotionPreset[] {
  return presets.map((p) => (p.id === id ? { ...p, name } : p));
}

export function updatePresetMfes(presets: PromotionPreset[], id: string, mfes: string[]): PromotionPreset[] {
  return presets.map((p) => (p.id === id ? { ...p, mfes: [...mfes].sort() } : p));
}
